import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import './../buttons/styles.scss'
import './styles.scss'
import { useDropzone } from 'react-dropzone'
import arrow from './../../images/upload-ico-white.svg'
import loading from './../../images/loading-white-ico.svg'
import { Base64 } from 'js-base64';
import { convertPrice, convertAmount } from './../../services/convertPrice';
import Text from '../text/Text';

const UploadDragDrop = ( props ) => {
    let [ uploadedFile, setUploadedFile ] = useState( false );
    let [ loadedApi, setLoadedApi ] = useState(false);
    let [ error, setError ] = useState(false);
    let [ errorItem, setErrorItem ] = useState(false);
    // let [ uploadValidate, setUploadValidate ] = useState(false); 
    let [ uploadedFileText, setUploadedFileText ] = useState( 'Wczytaj lub przeciągnij plik' );
    let fvFile       = useSelector(state => state.fvFile);
    let uploadValidate = useSelector(state => state.uploadValidate);
    const dispatch = useDispatch()

    let user = 'mjozwiak@grenke.pl';
    let pass = 'HrQKBQnKalJ3tsDx';
    let encode = Base64.encode(user + ":" + pass);

    useEffect(() => {
      if(props.forceValidate) {
        if(!uploadValidate) {
          setErrorItem(true);
        }else{
          setErrorItem(false);
        }
      }
    }, [props.forceValidate, uploadValidate])

    const onDrop = useCallback(acceptedFiles => {
        let whiteList = ['application/pdf', 'image/jpeg', 'image/png']
        const reader = new FileReader()
     
        reader.onabort = () => setUploadedFileText('Plik odrzucono')
        reader.onerror = () => setUploadedFileText('Błąd w trakcie wczytywania pliku')
        reader.onprogress = () => setUploadedFileText('Wczytuję plik')
        reader.onload = () => {
          setUploadedFile( true );
          setUploadedFileText(`Plik został wgrany poprawnie`);
        }
     
        acceptedFiles.forEach( async file => {

          if (whiteList.indexOf(file.type) === -1) {
            setUploadedFile( false );
            setUploadedFileText(`Nieprawidłowy <br/> format pliku`);
            uploadErrorSet( true );
            setError(true);
            setErrorItem(true);
            // dispatch( {type: 'ERROR_UPLOAD_FV', value:  true } );
          } else {
            setError(false);
            setErrorItem(false);
            // dispatch( {type: 'ERROR_UPLOAD_FV', value:  false } );
            let formData = new FormData();
            formData.append('file', file);
            dispatch({ type: 'FV_FILE_CHANGE', value: [file] })
            await upload(formData);
          }
        })
      }, [])

    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

    let uploadErrorSet = ( val ) => {
      dispatch({ type: 'ERROR_FV_UPLOAD_CHANGE', value: val })
    }
    
    let upload = (file) => {
        var data = null;
        let req = new XMLHttpRequest();

        req.open('POST', 'https://www.nudelta.pl/api/v1/documents');
        req.setRequestHeader("accept", "application/json"); 
        req.setRequestHeader("Authorization", "Basic " + encode); 
        req.send(file);
        setLoadedApi(true);
        setUploadedFileText('Trwa przetwarzanie');
        
        req.addEventListener("readystatechange", async function () {
          if (this.readyState === 4) {
            let resp = JSON.parse(req.response);
            let documentId = resp.document_id;
            await getDocumentInfo(documentId);
            setTimeout(async() => {
              

            }, 2000);

          }
        });
    }
    let getDocumentInfo = (document) => {
      let req = new XMLHttpRequest();
      req.open('GET', `https://www.nudelta.pl/api/v1/documents/${document}`);
      req.setRequestHeader("accept", "application/json"); 
      req.setRequestHeader("Authorization", "Basic " + encode);
      req.send();

      req.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          if (this.readyState === 4) {
            let data = JSON.parse(req.response);
            let status = data.state;
            console.log(status)
            // setUploadValidate(false);
            dispatch( {type: 'UPLOAD_VALIDATE', value:  false } );
            dispatch( {type: 'SUCCESS_FV', value:  false } );
            if ( status === 'failed') {
              setUploadedFileText(`Nieprawidłowy format pliku`);
              uploadErrorSet( true );
              setErrorItem(true);
              return false;
            }
            if ( status === 'done' ) {
              let items = [];
              let tables = data.data.tables;
              let seller = data.data.seller;
              // setUploadValidate(true);
              dispatch( {type: 'UPLOAD_VALIDATE', value:  true } );
              dispatch( {type: 'SUCCESS_FV', value:  true } );
              items = [ ...items, { 'tables': tables, 'seller': seller } ];
              generateProps(items);

            } else {
              setTimeout(async () => {
                await getDocumentInfo(document)

              }, 300);
            }

          }
        }
      });
    }

    let generateProps = (data) => {
      let tempArray = [];
      let rows = data[0].tables.rows;
      // console.log(data)
      rows.forEach(el => {
        let tempEqual = (parseFloat(el.amount.ans.val) * parseFloat(el.priceNetto.ans.val)).toFixed(2);
        tempEqual = tempEqual.toString();
        let amount = parseInt(el.amount.ans.val).toString();
        let name = el.name.ans.val;
        let price = convertPrice(el.priceNetto.ans.val);
        let equal = convertPrice( tempEqual );
        tempArray = [...tempArray, {
            type: '',
            name: name,
            price: price === "NaN" ? '' : price,
            quantity: price === "NaN" ? "" : amount,
            equal: equal,
            amortization: '',
            added: true
        }]
      });
      if ( rows.length > 0 ) {
        uploadErrorSet( false );
        setUploadedFileText('Wczytaj lub przeciągnij plik');
        setLoadedApi(false);
      } else {
        setUploadedFileText('Wczytaj lub przeciągnij plik');
        setLoadedApi(false);
        uploadErrorSet( true );
      }

      props.setFileData([{'tables': tempArray, 'seller': data[0].seller}]);
      dispatch( {type: 'ERROR_ADD_PRODUCT_FV_CHANGE', value:  false } );
    }
    return (
        <>
        <Text text="Wczytaj plik z fakturą proforma/zamówieniem od Dostawcy wskazującą dane przedmiotu" class={ errorItem ? "error-item bigger" : 'bigger' }/>
        <div className="upload-wrapper">
            <div className={"btn-wrap" + ( errorItem ? ' error-item' : '' )}>
                <div className={"btn white upload " + (loadedApi ? 'loading' : '') + " " + ( error ? 'error' : '')} {...getRootProps()}>
                    <input {...getInputProps()} />
                    <span dangerouslySetInnerHTML={ {__html: uploadedFileText} } />
                    <img className="upload-ico" src={ (loadedApi ? loading : arrow) } alt="Upload"/>
                </div>
            </div>
        </div>
        </>
    )
}

export default UploadDragDrop;